import { Action } from "../state";

/**
 * Wrapper to handle asynchronous actions such as API calls in our React
 * contexts and reducers.
 */
export async function asyncAction<
  R,
  SA extends Action,
  DA extends Action,
  FA extends Action,
  SAC extends (arg: Promise<R>) => SA,
  DAC extends (args: R) => DA,
  FAC extends () => FA
>(args: {
  dispatch: React.Dispatch<SA | DA | FA>;
  promise: Promise<R> | R;
  startAction?: SAC;
  doneAction: DAC;
  failAction: FAC;
}): Promise<void> {
  if (!(args.promise instanceof Promise)) {
    args.dispatch(args.doneAction(args.promise));
  }

  if (args.startAction) {
    args.dispatch(args.startAction(args.promise as Promise<R>));
  }

  try {
    args.dispatch(args.doneAction(await args.promise));
  } catch (err) {
    console.error("Failed to complete async request", err);
    args.dispatch(args.failAction());
  }
}
